import * as React from "react";
import { usePerson } from "--client/common/data/PeopleHooks";
import styled, { css } from "styled-components";
import { WorkspaceNameFromID } from "--floponents-web/atoms/DisplayName/WorkspaceSlugFromID";
import { Strings } from "--client/../strings/en";
import { seededRandomColorSet } from "--components/theme";
import { useCurrentWorkspace, useLoggedInUser } from "--client/common/hooks/useLoggedInUser";

export const StyledUserDisplayName = styled.span<{ variant?: "chip", colourize?: boolean, user_id: string, clickable: boolean }>`
	color: ${props => props.variant === "chip"
        ? props.theme.palette.text.primary
        : props.colourize ?
            seededRandomColorSet(props.user_id).main : "inherit"
    };  
    background-color: ${props => props.variant === "chip"
        ? seededRandomColorSet(props.user_id).main : "inherit"
    };  
    ${p => p.variant === "chip" ? css`border-radius:${p.theme.radius.small};` : ""};
    cursor: ${props => props.clickable && "cursor" || undefined};
    white-space: no-wrap;
`;


export const PersonPrefix = "@"
export const DisplayNameFromID: React.FC<{ belongingTo?: boolean, showYouForMe?: boolean, colourize?: boolean, includePrefix?: boolean, userId: string, variant?: "chip", onUpdate?: () => void, onClick?: () => void }> = props => {
    const [person] = usePerson(props.userId === "error" ? null : props.userId);
    React.useEffect(() => {
        if (person?.display_name && props.onUpdate)
            props.onUpdate()
    }, [props.onUpdate, person?.display_name]);
    if (props.userId === "error") return <>#Error</>
    return <DisplayNameFromPerson showYouForMe={props.showYouForMe} variant={props.variant} belongingTo={props.belongingTo} person={person || null} {...props} />
}

type DisplayNameFromPersonProps = {
    colourize?: boolean,
    includePrefix?: boolean,
    showYouForMe?: boolean,
    includeExternalWS?: boolean,
    belongingTo?: boolean,
    variant?: "chip",
    person: { workspace_id?: string, display_name: string, user_id: string } | null,
    onUpdate?: () => void,
    onClick?: () => void
}
export const DisplayNameFromPerson: React.FC<DisplayNameFromPersonProps> = props => {
    const person = props.person
    const user = useLoggedInUser()
    const workspace = useCurrentWorkspace()
    React.useEffect(() => {
        if (person?.display_name && props.onUpdate)
            props.onUpdate()
    }, [props.onUpdate, person?.display_name]);

    const prefix = props.includePrefix ? "@" : "";
    const wsName = person && person.workspace_id !== workspace && props.includeExternalWS ?
        person.workspace_id ?
            <> (<WorkspaceNameFromID workspace_id={person.workspace_id} />)</> :
            ` (${Strings.users.noWorkspace})` :
        "";

    if (person) return <StyledUserDisplayName
        colourize={props.colourize}
        variant={props.variant}
        user_id={person.user_id}
        clickable={!!props.onClick}
        onClick={props.onClick}>
        {
            (props.showYouForMe && user.user_or_identity_id === props.person?.user_id)
                ? <Strings.Inline>You</Strings.Inline>
                : <>
                    {prefix}{person?.display_name}{
                        props.belongingTo
                            ? "'s"
                            : ""
                    }{wsName && ` ${wsName}`}
                </>
        }
    </StyledUserDisplayName>
    return null;
}
